import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageFromStorage } from 'syf-js-utilities';
import PaymentSecurityModalContent from './components/modal';
const PaymentSecurity = () => {
    const { i18n } = useTranslation();
    const languageInStorage = getLanguageFromStorage();
    useEffect(() => {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(error => error);
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [i18n, languageInStorage]);
    return _jsx(PaymentSecurityModalContent, {});
};
export default PaymentSecurity;
